import React from "react";
import "./ok-page.css";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

function OkPage() {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.entries().next().value;
  const { t } = useTranslation();

  return (
    <div className="confirmation">
      <div className="confirmation-container">
        <span className="confirmation-booking-span">
          {t("okPage.bookingNumber")}: <b>{bookingId}</b>
        </span>
        <h1>{t("okPage.paymentProcessing")}</h1>
        <span>{t("okPage.emailConfirmation")}</span>
      </div>
    </div>
  );
}

export default OkPage;